export const getDaysInMonth = () =>
  new Array(31)
    .fill(null)
    .map((item, index) => ({ value: index + 1, label: `${index + 1}` }))
